"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _react = _interopRequireWildcard(require("react")),
    _draftJs = require("draft-js"),
    _RequestProvider = _interopRequireDefault(require("../../RequestProvider")),
    _api = require("../api"),
    _RichTextEditor = _interopRequireDefault(require("../components/RichTextEditor"));

function RichTextEditorRoot(a) {
  var b = a.children,
      c = a.placeholder,
      d = a.editorState,
      e = a.onUpdateContent,
      f = a.inputType,
      g = a.onSave,
      h = a.disabled,
      i = a.hideControls,
      j = a.onCancel,
      k = a.organisationId,
      l = a.onBlur,
      m = a.onFocus;
  return _react["default"].createElement(_RequestProvider["default"], {
    requests: {
      getUsersByName: (0, _api.getUsersByName)()
    }
  }, function (a) {
    return _react["default"].createElement(_RichTextEditor["default"], (0, _extends2["default"])({}, a, {
      onUpdateContent: e,
      placeholder: c,
      editorState: d,
      inputType: f,
      onSave: g,
      disabled: h,
      onCancel: j,
      organisationId: k,
      hideControls: i,
      onBlur: l,
      onFocus: m
    }), b);
  });
}

var _default = (0, _react.memo)(RichTextEditorRoot);

exports["default"] = _default;